// extracted by mini-css-extract-plugin
export default {"blogFeed":"styles_blogFeed__H8Yp6","feedInner":"styles_feedInner__IIo1N"};